export default state => state.overlay?.shouldPauseFocusTrap;
